const Stories = () => {
    return ( 
        <div className="stories">
            <div class="topleft">
                <p>Logo</p>
            </div>
            <div class="middle">
                <h1>COMING SOON</h1>
                <hr/>
                <p>35 days left</p>
            </div>
            <div class="bottomleft">
                <p>Some text</p>
            </div>
        </div>
     );
}
 
export default Stories;